
import React, { Suspense, lazy } from 'react';
import {BrowserRouter as Router, Route, Routes, useLocation} from 'react-router-dom';

import AdminNavbar from '../app/AdminNavbar';
import AdminLoginPage from '../app/pages/user/AdminLoginPage';
import IndexPage from '../app/pages/IndexPage';
import AdminProtectedRoute from "./AdminProtectedRoute";
import Spinner from "../app/components/Spinner";

import '../App.css';
import EntityListPage from "../app/pages/EntityListPage";

const MailCampaignPage = lazy(() => import("../app/pages/MailCampaignPage"));




function AdminLayout() {
    return (
        <>
            <ConditionalSidebar />
            <Routes>
                <Route path="/" element={<AdminLoginPage/>}/>
                <Route
                    path="/index"
                    element={<AdminProtectedRoute element={<IndexPage />}  />}
                />
                <Route
                    path="/application"
                    element={<EntityListPage type="application" />}
                />

                <Route
                    path="/enrollment"
                    element={<EntityListPage type="enrollment" />}
                />

                <Route
                    path="/term"
                    element={<AdminProtectedRoute element={<EntityListPage type="term" />} />}
                />

                <Route
                    path="/mail"
                    element={(
                        <AdminProtectedRoute
                            element={(
                                <Suspense fallback={<Spinner />}>
                                    <MailCampaignPage />
                                </Suspense>
                            )}
                        />
                    )}
                />

            </Routes>

        </>
    );
}


const ConditionalSidebar = () => {
    const location = useLocation();
    const noNavbarRoutes = [ '/'];

    return noNavbarRoutes.includes(location.pathname) ? null : <AdminNavbar/>;
};





export default AdminLayout;
